import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import getDisplayName from '../utils/get-display-name';
import { useTheme } from './jss';
import createUseStyles from './create-use-styles';
import withBaseTheme from './with-base-theme';
export default function withStyles(styles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useStyles = createUseStyles(styles, options);
  return function (Component) {
    var StyledComponent = withBaseTheme(forwardRef(function StyledComponent(props, ref) {
      var theme = useTheme();
      var classes = useStyles();
      return React.createElement(Component, _extends({}, props, {
        ref: ref,
        theme: theme,
        classes: classes
      }));
    }));
    var displayName = options.name || getDisplayName(Component);
    StyledComponent.displayName = "RamblerUI(".concat(displayName, ")");
    return StyledComponent;
  };
}